firebird.factory('camaroService', [
    '$rootScope',
    '$window',
    'logService',
    'desktopNotificationService',
    function ($rootScope, $window, logService, desktopNotificationService) {
        let isUnloading = false;
        let isClosing = false;
        let isMeetingInitiated = false;
        let isNavigating = false;
        let navigationUrl = null;

        const logger = new LogServiceWrapper(logService, 'camaroService');

        const service = {
            getIsUnloading: getIsUnloading,
            getIsClosing: getIsClosing,
            getIsMeetingInitiated: getIsMeetingInitiated,
            getIsNavigating: getIsNavigating,
            getNavigationUrl: getNavigationUrl,
            setIsUnloading: setIsUnloading,
            setIsClosing: setIsClosing,
            setIsMeetingInitiated: setIsMeetingInitiated,
            setIsNavigating: setIsNavigating,
            setNavigationUrl: setNavigationUrl,
            reset: reset,
            closeWindow: closeWindow,
            closeWindowForced: closeWindowForced,
            onSessionCompleted: onSessionCompleted
        };

        return service;

        ////////////////////////

        function getIsMeetingInitiated() {
            return isMeetingInitiated;
        }

        function getIsUnloading() {
            return isUnloading;
        }

        function getIsClosing() {
            return isClosing;
        }

        function getIsNavigating() {
            return isNavigating;
        }

        function getNavigationUrl() {
            return navigationUrl;
        }

        function setIsUnloading(flag) {
            isUnloading = flag;
        }

        function setIsClosing() {
            desktopNotificationService.disableNotifications();
            isClosing = true;
        }

        function setIsNavigating(flag) {
            isNavigating = flag;
        }

        function setIsMeetingInitiated() {
            desktopNotificationService.disableNotifications();
            isMeetingInitiated = true;
        }

        function setNavigationUrl(url) {
            navigationUrl = url;
        }

        function reset() {
            logger.log('reset', 'calling camaroService.reset ...');

            desktopNotificationService.enableNotifications();

            isClosing = false;
            isUnloading = false;
            isMeetingInitiated = false;
            isNavigating = false;
            navigationUrl = null;
        }

        function closeWindow() {
            logger.log('closeWindow', 'calling camaroService.closeWindow ...');
            desktopNotificationService.disableNotifications();
            $window.preloadedApi.windowManagement.close();
        }

        function closeWindowForced() {
            logger.log('closeWindowForced', 'calling camaroService.closeWindowForced ...');
            desktopNotificationService.disableNotifications();
            $rootScope.$broadcast('removeOnBeforeUnloadConfirmation');
            $window.preloadedApi.windowManagement.close();
        }

        function onSessionCompleted() {
            desktopNotificationService.disableNotifications();
        }
    }
]);
